export const VossTimeLengthUnits = {
    Day: 0,
    Month: 1,
    Year: 2,
};

export const VossTimeLengthUnitsText = {
    [VossTimeLengthUnits.Day]: 'vosstimelengthunits.day',
    [VossTimeLengthUnits.Month]: 'vosstimelengthunits.month',
    [VossTimeLengthUnits.Year]: 'vosstimelengthunits.year',
};